import { createSelector } from 'reselect';
import { getpath } from './location';

const getBannerDetails = state => state.banner;

const getHomeReducer = state => state.HomeReducer;
const getLuxeTopNav = state => state.luxeTopNav;
const getBannerProductsReducer = state => state.bannerProducts || {};

const checkIsActive = (nativeCategoryPageId = '', path = ''): boolean => {
  if (path === '/') return false;

  const pwq = path.split('/shop');
  const pageId = nativeCategoryPageId.split('/shop');

  if (pageId[1] === pwq[1]) {
    return true;
  }
  return false;
};

const getPageDetails = createSelector(getBannerDetails, ({ pageDetails = [] }) => {
  return pageDetails.reduce((acc, curr) => {
    if (curr.typeCode && ['MSITE', 'ALL'].includes(curr.application)) {
      return [...acc, curr];
    }
    return acc;
  }, []);
});

const getPageTitle = createSelector(getBannerDetails, ({ pageDetails = [] }) => {
  const titleObj = pageDetails.filter(({ pageTitle }) => !!pageTitle);
  return titleObj?.[0]?.pageTitle;
});

const getHomeCatgory = createSelector(getHomeReducer, getpath, ({ pageDetails = [] }, path) => {
  let luxeHomeTabs = pageDetails.filter(page => page.nativeCategoryNavigationListDetails);
  luxeHomeTabs = luxeHomeTabs.length
    ? luxeHomeTabs[0].nativeCategoryNavigationListDetails.filter(
        tab => tab.nativeCategoryPageId !== '/shop/luxe'
      )
    : [];
  return luxeHomeTabs.map(({ defaultNode, nativeCategoryName, nativeCategoryPageId }) => {
    return {
      pageId: nativeCategoryPageId,
      label: nativeCategoryName,
      selected: checkIsActive(nativeCategoryPageId, path)
    };
  });
});

const getHomeCatgoryCms = createSelector(getLuxeTopNav, getpath, (navArr, path) => {
  return navArr.map(({ name, url }) => {
    return {
      pageId: url,
      label: name,
      selected: checkIsActive(url, path)
    };
  });
});

const getBannerProducts = createSelector(getBannerProductsReducer, ({ loading, data, error }) => {
  return {
    loading,
    data,
    error
  };
});

export {
  getBannerDetails,
  getPageDetails,
  getPageTitle,
  getHomeCatgory,
  getHomeCatgoryCms,
  getBannerProducts
};
